import { AxiosService } from '@services'
import { Endpoints } from '@network/endpoints'
import { IPayload } from '@network/models/global.model'
import {
  IInvoiceGroup,
  IGetInvoiceGroupsParams,
  IPostInvoiceGroupParams,
  IPutInvoiceGroupParams,
} from '@network/models/invoice-group.model'

export class InvoiceGroupsApi {
  constructor(private axios: AxiosService) {}

  getInvoiceGroups = async (params?: IGetInvoiceGroupsParams) => {
    const response = await this.axios.get<IPayload<IInvoiceGroup[]>>(
      Endpoints.getInvoiceGroups,
      params,
    )
    return response
  }

  getInvoiceGroup = async (id: number) => {
    const response = await this.axios.get<IPayload<IInvoiceGroup>>(
      Endpoints.getInvoiceGroup(id),
    )
    return response
  }

  postInvoiceGroup = async (params: IPostInvoiceGroupParams) => {
    const response = await this.axios.post<IPayload<IInvoiceGroup>>(
      Endpoints.postInvoiceGroup,
      params,
    )
    return response
  }

  putInvoiceGroup = async (id: number, params: IPutInvoiceGroupParams) => {
    const response = await this.axios.put<IPayload<IInvoiceGroup>>(
      Endpoints.putInvoiceGroup(id),
      params,
    )
    return response
  }

  deleteInvoiceGroup = async (id: number) => {
    const response = await this.axios.delete<{}>(
      Endpoints.deleteInvoiceGroup(id),
    )
    return response
  }
}
